
<script>
    import Header from '../global/header.svelte'
    import { memberStore } from '../../store.js';
    import { afterUpdate, onMount } from 'svelte';
    import moment from 'moment';
   // import Push from '../widgets/push.svelte'

    let user;
    let checkingBalance = false;
    let xmasPromoActive = false;
    let promotionImage;
    let gtag;
    
    memberStore.subscribe(member => {
        user = member
    });

    onMount( () => {
        // -- If we have no zip then we must get one
        var zip = localStorage.getItem('zip');
        getBalance();
        checkPromoActive();
	});

    function trackDataLayerAction() {
        dataLayer.push({
            'event':'CustomEvent',
            'category':'Member Benefits Portal',
            'action':'Offer Interaction',
            'label':'Click'
        });
    }

 
    function getBalance() {
        checkingBalance = true
        var formData = new FormData();
        formData.append('number', user.number);
        formData.append('zip', localStorage.getItem('zip') );

        fetch("https://api.southernco-op.co.uk/member/getBalance", {
            headers: {
                'Accept': 'application/json',
            },
            method: "POST",
            body: formData
        })
        .then( response => {
            checkingBalance = false;
            return response.json();
        }).then( data => {
                memberStore.set({
                "name":user.name,
                "points":data.points,
                "number":user.number,
                "last_update": moment(new Date()).format("DD/MM/YYYY")
            }); 
        })                
        .catch( err => {
                checkingBalance = false;
        }); 

        checkingBalance = false;
    }

    function checkPromoActive() {
        fetch("https://api.southernco-op.co.uk/member/hasPromoNew", {
            headers: {
                'Accept': 'application/json',
            },
            method: "GET",
        })
        .then( response => response.json() )
        .then( data => { 
           
            if( !data.error ) {

                promotionImage = data.comp_img;
                gtag = data.gtag;

                xmasPromoActive = true 

                if( data.day != 99 ) {
                    xmasPromoActive = true 
                } else {
                    xmasPromoActive = false 
                }
               
            } 
        } );          
    }


    function getUserFirstName( name ) {

        if( !name ) return;

        var splits = name.split(" ");
        if( splits[0] ) {
            return splits[0]
        } else {
            return "";
        }

    }

 
</script>

<svelte:head>
    <title>Customer Dashboard</title>
</svelte:head>

<style>
    .lead {
        position: relative;
        margin-bottom: 1em
    }
   

    h1 {
        font-weight: 300;
        font-size: 50px;
        font-size: 5.0rem;
        line-height: 1.1;
        margin: 0;
        color: var(--brand-color);
    }
    h1 span {
        display: block;
    }

    p {
        font-size: 18px;
        font-size: 1.8rem;
        margin: 0;
    
    }
    p span {
         color: var(--brand-color);
         
    }

    small {
        font-size: 12px;
        font-size: 1.2rem;

    }

    .meta {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 2em 0 0em 0;
        font-weight: 500;
        position: relative;
    }

    @media screen and ( max-width: 374px ) {
        .meta {
            flex-wrap: wrap;
        }
        .meta > * {
            flex-basis: 100%;
        }
    }

    .minor {
        text-align: center;
        opacity: .7;
        
    }

    .lds-ripple {
        position:absolute;
        top: -30px;
        right: 0;
    }

    .ben-card {
        background: #B6D4DB;
        padding: 1.5em 2em;
        border-radius: 25px;
        text-align: center;
        margin-bottom: 2em;
        display: none;
    }

    .ben-card em {
        color: var(--dark-color);
        font-style: normal;
         font-size: 18px;
        font-size: 1.8rem;
        margin: 0;
       font-weight: 500;
    }

    .refresh {
        background: none;
        border:none;

    }

    .refresh img {
        width: 18px;
        position: relative;
        top: 5px;
    }

    .buttons li:not(:last-child) img {
        max-width: 180px;
        margin-left: auto;
        margin-right: auto;
    }

   .notice strong {
        font-size: 13px;
   }
    .notice {
        
         font-size: 13px;
          margin-bottom: 1.5em;
         
    }

    .meta p {
       
       margin: 0;
    }

    .promotion {
        margin-bottom: 1em;
    }

    .xmasProm {
        display: block;
        
        text-align: center;
        
        margin-bottom: 1.5em;
       
    }

    .button-offer {
        text-align: center;
        background: var(--light-color);
        display: block;
        border-radius: 15px;
        margin-bottom: 1.5em;
    }

    .button-offer img {
        margin: 0 auto;
        display: block;
    }
  

</style>

<Header title="" url="" />


<section>
    <div>
        

        <header class="lead">
             <h1>Hello <span>{ getUserFirstName(user.name) }</span></h1>
        </header>

        <!-- 
        <div class="meta">
        <p>You have <span>{user.points} pts</span> </p>

        {#if checkingBalance}
          <div  class="lds-ripple lds-ripple--small"><div></div><div></div></div>
        {:else}
            <small>Balance as of {user.last_update} <button class="refresh" on:click={getBalance}><img src="svg/refresh.svg" alt="Twitter" /></button> </small>
        {/if}

        
        
        </div>

        <div class="notice notice--info">
            Points shown are for spend <strong>28/01/24 – 25/01/25</strong>
        </div>
        -->

         <div class="desktop-message">This app is not optimised for desktop devices, please access this link on your mobile phone</div>


        {#if xmasPromoActive}
            <a class="xmasProm" href="/xmas-new/hub/{gtag}"><img src="{promotionImage}" alt="Christmas Promotion" /></a>
        {/if}

        <!-- 
        <a class="button-offer" target="_blank" href="https://southern.coop/membership/member-offers?utm_source=app-button&utm_medium=app-member-offers"><img src="svg/offer-badge.svg" alt="Member Offer" /></a>
        -->

        <ul class="buttons">

            <li>
                <a href="/my-card">
                <div>
                    <img src="svg/home2024/card.svg" alt="My Card" />
                    <em>My card</em>
                </div>
                </a>
            </li>

             <li>
                <a target="_blank" href="https://southern.coop/membership/member-offers?utm_source=app-button&utm_medium=app-member-offers">
                <div>
                    <img src="svg/home2024/offers.svg" alt="Offers in store" />
                    <em>Latest member offers</em>
                </div>
                </a>
            </li>

            <li>
                <a  target="_blank" href="https://southern.coop/what-we-do/food/recipes">
                <div>
                    <img src="svg/home2024/recipes.svg" alt="Offers in store" />
                    <em>Recipes</em>
                </div>
                </a>
            </li>

             <li>
                <a  target="_blank" href="https://southern.coop/membership/voices-votes/talk-to-us">
                <div>
                    <img src="svg/home2024/talk.svg" alt="News" />
                    <em>Talk to us</em>
                </div>
                </a>
            </li>

    <!-- 
             <li>
                <a target="_blank" href="https://southern.coop/membership/events">
                <div>
                    <img src="svg/events.svg" alt="Events" />
                    <em>Events</em>
                </div>
                </a>
            </li> -->


            <li>
                <a href="/store-finder">
                    <div>
                        <img src="svg/pin.svg" alt="Find your local Co-op" />
                        <em> Find your local Co-op</em>
                    </div>
               </a>
            </li>
           
        </ul>
     <!-- 
        <a class="ben-card" on:click|once={trackDataLayerAction} href="https://southerncoopbenefits.group-login.com/login" target="_blank">
            <img src="svg/members-bens-logo.svg" alt="My Card" />
            <em>Members Benefits Portal</em>
        </a>
        -->

       
     
        <p class="minor"><a href="/logout">Logout</a></p>
    </div>
</section>